import React from 'react';
import './PageHeader.css';

/**
 * PageHeader — Encabezado estándar del sistema GestiónEJP.
 *
 * DOS variantes únicas (no hay una tercera):
 *
 *  variante="plano"   → Fondo transparente (--bg-page). Para Tableros y Listados.
 *                       Ícono en color de área, título oscuro, botón de acción a la derecha.
 *
 *  variante="banner"  → Fondo sólido (--area-solid). Para Formularios y Fichas de Detalle.
 *                       Ícono y texto siempre blancos.
 *
 * El componente no necesita saber de qué área es: hereda --area-solid del
 * contexto (.area-rti, .area-art, etc.) que envuelve la página.
 *
 * Props:
 *   icono       {string}    Nombre del ícono Bootstrap Icons, sin prefijo "bi-". Ej: "people-fill"
 *   titulo      {string}    Texto principal (h1)
 *   descripcion {string}    Subtítulo descriptivo (opcional)
 *   variante    {string}    "plano" (default) | "banner"
 *   accion      {ReactNode} Botón u otro elemento a la derecha (opcional)
 *   className   {string}    Clases adicionales para el contenedor (opcional)
 */
const formatearIcono = (ico) => {
    if (!ico) return '';
    return ico.replace(/^bi\s+bi-/, '').replace(/^bi-/, '');
};

export default function PageHeader({
    icono,
    titulo,
    descripcion,
    variante = 'plano',
    accion,
    className = '',
}) {
    const icoNorm = formatearIcono(icono);

    if (variante === 'banner') {
        return (
            <div className={`ph-banner ${className}`}>
                <div className="ph-banner__inner">
                    <div className="ph-banner__left">
                        {icoNorm && (
                            <i
                                className={`bi bi-${icoNorm} ph-banner__icono`}
                                aria-hidden="true"
                            />
                        )}
                        <div>
                            <h1 className="ph-banner__titulo">{titulo}</h1>
                            {descripcion && (
                                <p className="ph-banner__desc">{descripcion}</p>
                            )}
                        </div>
                    </div>
                    {accion && (
                        <div className="ph-banner__accion">{accion}</div>
                    )}
                </div>
            </div>
        );
    }

    // variante === 'plano' (default)
    return (
        <div className={`ph-plano ${className}`}>
            <div className="ph-plano__left">
                {icoNorm && (
                    <i
                        className={`bi bi-${icoNorm} ph-plano__icono`}
                        aria-hidden="true"
                    />
                )}
                <div>
                    <h1 className="ph-plano__titulo">{titulo}</h1>
                    {descripcion && (
                        <p className="ph-plano__desc">{descripcion}</p>
                    )}
                </div>
            </div>
            {accion && (
                <div className="ph-plano__accion">{accion}</div>
            )}
        </div>
    );
}
